import React from "react"
import styled, { css } from "styled-components"

import { mixins } from "../styles"

import CheckmarkCircleSVG from "../images/icons/checkmark-circle.inline.svg"

const ConfirmationMessage = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  justify-content: center;
  text-align: center;
  ${mixins.title6}

  ${(props) =>
    props.$status &&
    css`
      color: var(--color-${props.$status});
    `}
`

const ConfirmationIcon = styled.div`
  margin: 0 auto 20px;
`

const Confirmation = ({ status, text }) => (
  <ConfirmationMessage $status={status}>
    <ConfirmationIcon>
      {status === "success" && <CheckmarkCircleSVG />}
    </ConfirmationIcon>
    <div>{text}</div>
  </ConfirmationMessage>
)

export default Confirmation
